import { letraAPuntos } from '@cessi/shared';
import fichasRaw from './fichas-framework.json' with { type: 'json' };
export const FRAMEWORK_VERSION = 'v1.4';
export const FICHAS_FRAMEWORK = fichasRaw;
const BY_CODIGO = new Map(FICHAS_FRAMEWORK.map((f) => [f.codigo, f]));
export function fichaPorCodigo(codigo) {
    return BY_CODIGO.get(codigo);
}
/** Orden canónico de fichas (empates). */
export const ORDEN_FICHAS = FICHAS_FRAMEWORK.map((f) => f.codigo);
/** `G.1` → `G-1` (el sitio oficial distingue mayúsculas en los nombres de archivo). */
export function codigoASlug(codigo) {
    return codigo.replace(/\./g, '-');
}
export function pathCapacidad(codigo) {
    return `capacidades/${codigoASlug(codigo)}.html`;
}
const LETRAS = new Set(['a', 'b', 'c', 'd', 'na', 'ns', 'nc']);
/**
 * Parámetro `r` del sitio: nivel 1-4 de las 21 capacidades en orden 1.1…G.4.
 * "No aplica" (0 puntos) se muestra como N1; si falta algún ítem se omite `r`.
 */
export function nivelesParaMapa(respuestas) {
    const niveles = [];
    for (const f of FICHAS_FRAMEWORK) {
        const letra = respuestas[f.columna];
        if (typeof letra !== 'string' || !LETRAS.has(letra))
            return null;
        niveles.push(Math.max(1, letraAPuntos(letra)));
    }
    return niveles;
}
/**
 * URL a recomendacion.html del sitio del framework. Los datos van en el fragmento (#…):
 * no llegan al servidor, a los logs ni al Referer.
 */
export function urlRecomendacion(input) {
    const base = input.baseUrl.replace(/\/$/, '');
    const params = new URLSearchParams();
    params.set('c', input.fichas.join(','));
    params.set('n', input.nivelesFicha.join(','));
    const r = input.respuestas ? nivelesParaMapa(input.respuestas) : null;
    if (r)
        params.set('r', r.join(','));
    params.set('p', input.nivelesDim.join(','));
    if (input.organizacion)
        params.set('org', input.organizacion);
    if (input.arquetipo)
        params.set('arq', input.arquetipo);
    if (input.segmento)
        params.set('seg', input.segmento);
    if (input.fecha)
        params.set('fecha', input.fecha);
    return `${base}/recomendacion.html#${params.toString()}`;
}
/** Fecha corta para el sitio (dd/mm/aaaa, hora de Buenos Aires). */
export function fechaRecomendacion(d) {
    return d.toLocaleDateString('es-AR', {
        timeZone: 'America/Argentina/Buenos_Aires',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}
export function urlCapacidad(baseUrl, codigo, nivel) {
    const base = baseUrl.replace(/\/$/, '');
    const path = pathCapacidad(codigo);
    return nivel != null ? `${base}/${path}?nivel=${nivel}` : `${base}/${path}`;
}
/** Textos cortos para UI/email a partir de códigos de ficha. */
export function textosFichas(codigos) {
    return codigos.map((c) => {
        const f = fichaPorCodigo(c);
        return f ? `${f.codigo} · ${f.nombre}: ${f.accionN1N2}` : c;
    });
}
//# sourceMappingURL=fichas.js.map